import React from "react";
import classes from "./MessageBox.module.css";

const MessageBox = ({ children }) => {
  return <div className={classes.notification}>{children}</div>;
};

export default MessageBox;
